(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gpw-ab-sticky"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var bar = root.querySelector('[data-ab-sticky]');
    if (!bar || bar.dataset.wired) return;
    bar.dataset.wired = '1';

    var footer = document.querySelector('.gpw-ft__body') || document.querySelector('.gpw-ft') || document.querySelector('footer');

    function update() {
      var past = window.pageYOffset > window.innerHeight * 0.9;
      var footerClear = true;
      if (footer) {
        footerClear = footer.getBoundingClientRect().top > window.innerHeight - 40;
      }
      if (past && footerClear) bar.classList.add('is-on');
      else bar.classList.remove('is-on');
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  document.querySelectorAll('.gpw-ab-sticky-section').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList.contains('gpw-ab-sticky-section')) init(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gpw-buy-drawer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gpw-buy-drawer')) {
    class GpwBuyDrawer extends HTMLElement {
      connectedCallback() {
        this.variantId = this.dataset.variantId;
        this.cartUrl = this.dataset.cartUrl || '/cart';
        this.plans = { 1: this.dataset.plan1, 2: this.dataset.plan2, 3: this.dataset.plan3 };
        this.icons = {};
        this.querySelectorAll('[data-gpw-icons] [data-icon]').forEach((el) => { this.icons[el.dataset.icon] = el.innerHTML; });

        this.CHEWS_PER_JAR = 60;
        this.LIST = 49;
        this.PRICING = {
          subscription: [ { qty: 1, total: 39.20, save: 20 }, { qty: 2, total: 68.60, save: 30 }, { qty: 3, total: 88.20, save: 40 } ],
          oneTime: [ { qty: 1, total: 49.00, save: 0 }, { qty: 2, total: 78.40, save: 20 }, { qty: 3, total: 110.25, save: 25 } ]
        };
        this.RECUR = { 1: 41.65, 2: 83.30, 3: 124.95 };
        this.SIZES = [
          { id: 'sm', label: 'Small dog', chewsPerDay: 1 },
          { id: 'md', label: 'Medium dog', chewsPerDay: 2 },
          { id: 'lg', label: 'GIANT dog', chewsPerDay: 3 }
        ];

        this.state = { mode: 'subscription', sizeId: null, qty: null, touched: false };

        this.scrim = this.querySelector('[data-gpw-scrim]');
        this.drawer = this.querySelector('[data-gpw-drawer]');
        this.sticky = this.querySelector('[data-gpw-sticky]');
        this.jarsEl = this.querySelector('[data-gpw-jars]');
        this.qtyStep = this.querySelector('[data-gpw-qty-step]');
        this.sizeNote = this.querySelector('[data-gpw-size-note]');
        this.cadenceEl = this.querySelector('[data-gpw-cadence]');
        this.hintEl = this.querySelector('[data-gpw-hint]');
        this.addBtn = this.querySelector('[data-gpw-add]');
        this.addLabel = this.querySelector('[data-gpw-add-label]');
        this.addPrice = this.querySelector('[data-gpw-add-price]');
        this.addError = this.querySelector('[data-gpw-add-error]');
        this.renewEl = this.querySelector('[data-gpw-renew]');
        this.shipEl = this.querySelector('[data-gpw-ship]');

        this.bind();
        this.renderJars();
        this.setupSticky();
        this.checkDeepLink();
      }

      // Auto-open when deep-linked from another page (e.g. Science CTA →
      // /products/gut-care-chew?buy=open, or #order / #buy). Cleans the URL after.
      checkDeepLink() {
        var wants = false;
        try { if (new URLSearchParams(window.location.search).get('buy') === 'open') wants = true; } catch (e) {}
        if (window.location.hash === '#order' || window.location.hash === '#buy') wants = true;
        if (!wants) return;
        var self = this;
        var replaceKey = null;
        try { replaceKey = new URLSearchParams(window.location.search).get('replace'); } catch (e) {}
        requestAnimationFrame(function () { replaceKey ? self.openForChange(replaceKey) : self.open(); });
        try {
          var url = new URL(window.location.href);
          url.searchParams.delete('buy');
          url.searchParams.delete('replace');
          if (url.hash === '#order' || url.hash === '#buy') url.hash = '';
          window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
        } catch (e) {}
      }

      fmt(n) { return '$' + n.toFixed(2); }
      perChew(total, qty) { return (total / (qty * this.CHEWS_PER_JAR)).toFixed(2); }
      tiers() { return this.PRICING[this.state.mode]; }
      recommended() { const s = this.SIZES.find(x => x.id === this.state.sizeId); return s ? Math.min(3, Math.max(1, s.chewsPerDay)) : null; }

      bind() {
        document.addEventListener('click', (e) => {
          if (e.target.closest('[data-gpw-open-buy]')) { e.preventDefault(); this.open(); }
        });
        this.querySelector('[data-gpw-close]').addEventListener('click', () => this.close());
        this.scrim.addEventListener('click', () => this.close());
        this.querySelectorAll('[data-gpw-mode]').forEach((b) => b.addEventListener('click', () => this.setMode(b.dataset.gpwMode)));
        this.querySelectorAll('[data-gpw-size]').forEach((b) => b.addEventListener('click', () => this.pickSize(b.dataset.gpwSize)));
        this.addBtn.addEventListener('click', () => this.addToCart());
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.classList.contains('is-open')) this.close(); });
      }

      open() {
        this.classList.add('is-open');
        this.scrim.hidden = false; requestAnimationFrame(() => this.scrim.classList.add('is-open'));
        this.drawer.classList.add('is-open'); this.drawer.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
        if (this.updateSticky) this.updateSticky();
      }
      // Opened from a subscription line's "Change" in the cart: preselect that
      // line's size and jars, and on Add swap the old line for the new pick.
      async openForChange(key) {
        this.replaceKey = key;
        this.open();
        try {
          const cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
          const line = cart.items.find((i) => i.key === key);
          if (!line) { this.replaceKey = null; return; }
          if (line.selling_plan_allocation) this.setMode('subscription');
          const label = line.properties && line.properties['Dog size'];
          const size = this.SIZES.find((s) => s.label === label);
          if (size) this.pickSize(size.id);
          if (size && this.tiers().some((t) => t.qty === line.quantity)) this.pickQty(line.quantity);
        } catch (e) { console.error('[gpw-buy-drawer]', e); }
      }
      close() {
        this.replaceKey = null;
        this.classList.remove('is-open');
        this.scrim.classList.remove('is-open'); this.drawer.classList.remove('is-open');
        this.drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        if (this.updateSticky) this.updateSticky();
        setTimeout(() => { if (!this.classList.contains('is-open')) this.scrim.hidden = true; }, 320);
      }

      setMode(mode) {
        this.state.mode = mode;
        this.querySelectorAll('[data-gpw-mode]').forEach((b) => b.classList.toggle('is-active', b.dataset.gpwMode === mode));
        this.shipEl.textContent = mode === 'subscription' ? 'Free shipping' : 'Free shipping over $60';
        this.renderJars(); this.renderCadence(); this.renderFooter();
      }

      pickSize(id) {
        this.state.sizeId = id; this.state.touched = false;
        this.state.qty = this.recommended();
        this.querySelectorAll('[data-gpw-size]').forEach((b) => b.classList.toggle('is-active', b.dataset.gpwSize === id));
        const s = this.SIZES.find(x => x.id === id);
        const days = this.state.qty ? Math.floor((this.state.qty * this.CHEWS_PER_JAR) / s.chewsPerDay) : null;
        this.sizeNote.hidden = false;
        this.sizeNote.innerHTML = this.icons.check + '<span>' + s.chewsPerDay + ' chew' + (s.chewsPerDay === 1 ? '' : 's') + '/day' + (days ? ' · ~<strong>' + days + '-day</strong> supply' : '') + '</span>';
        this.qtyStep.classList.remove('is-locked');
        this.renderJars(); this.renderCadence(); this.renderFooter();
      }

      pickQty(q) { this.state.qty = q; this.state.touched = true; this.renderJars(); this.renderCadence(); this.renderFooter(); }

      renderJars() {
        const rec = this.recommended();
        this.hintEl.hidden = !(this.state.sizeId && !this.state.touched);
        this.jarsEl.innerHTML = this.tiers().map((t) => {
          const active = t.qty === this.state.qty;
          const isRec = rec === t.qty;
          return '<button type="button" class="gpw-bd__jar' + (active ? ' is-active' : '') + '" data-jar="' + t.qty + '">' +
            (isRec ? '<span class="gpw-bd__jar-rec">Recommended</span>' : '') +
            '<span class="gpw-bd__jar-num">' + t.qty + '</span>' +
            '<span class="gpw-bd__jar-unit">' + (t.qty === 1 ? 'jar' : 'jars') + '</span>' +
            '<span class="gpw-bd__jar-total">' + this.fmt(t.total) + '</span>' +
            '<span class="gpw-bd__jar-per">$' + this.perChew(t.total, t.qty) + '/chew</span>' +
            (t.save > 0 ? '<span class="gpw-bd__jar-save">Save ' + t.save + '%</span>' : '') +
            '</button>';
        }).join('');
        this.jarsEl.querySelectorAll('[data-jar]').forEach((b) => b.addEventListener('click', () => this.pickQty(parseInt(b.dataset.jar, 10))));
      }

      renderCadence() {
        const { sizeId, qty, mode } = this.state;
        if (!sizeId || !qty) { this.cadenceEl.hidden = true; return; }
        const s = this.SIZES.find(x => x.id === sizeId);
        const rec = this.recommended();
        const dogsLabel = 'your ' + s.label.toLowerCase();
        const days = Math.floor((qty * this.CHEWS_PER_JAR) / s.chewsPerDay);
        const under = qty < rec;
        if (mode === 'oneTime' && !under) { this.cadenceEl.hidden = true; return; }
        let html = this.icons.calendar + '<div>';
        if (under) {
          html += "That's a <strong>" + days + '-day supply</strong> for ' + dogsLabel + '. Most parents pick ' + rec + ' jars for a full 60-day cycle. ' +
            '<a data-gpw-upgrade="' + rec + '">' + (mode === 'subscription' ? 'Switch to ' + rec + ' jars' : 'Add ' + rec + ' jars') + '</a>';
        } else if (qty === rec) {
          html += '<strong>Ships every 60 days</strong>, a perfect 60-day supply for ' + dogsLabel + '.';
        } else {
          html += "That's a <strong>" + days + '-day supply</strong> for ' + dogsLabel + ". We'll still ship every 60 days, so you'll build a small surplus. Adjust anytime in your account.";
        }
        html += '</div>';
        this.cadenceEl.innerHTML = html; this.cadenceEl.hidden = false;
        const up = this.cadenceEl.querySelector('[data-gpw-upgrade]');
        if (up) up.addEventListener('click', () => this.pickQty(parseInt(up.dataset.gpwUpgrade, 10)));
      }

      renderFooter() {
        const { sizeId, qty, mode } = this.state;
        const ready = !!(sizeId && qty);
        this.addError.hidden = true;
        this.addBtn.disabled = !ready;
        if (!ready) {
          this.addLabel.textContent = sizeId ? 'Pick quantity' : "Pick your dog's size";
          this.addPrice.hidden = true; this.renewEl.hidden = true; return;
        }
        const t = this.tiers().find((x) => x.qty === qty);
        this.addLabel.textContent = 'Add to cart';
        this.addPrice.hidden = false;
        const was = t.save > 0 ? '<span class="gpw-bd__add-was">' + this.fmt(this.LIST * qty) + '</span>' : '';
        this.addPrice.innerHTML = was + '<span>' + this.fmt(t.total) + '</span>';
        if (mode === 'subscription') {
          this.renewEl.hidden = false;
          this.renewEl.textContent = 'Renews ' + this.fmt(this.RECUR[qty]) + ' every 60 days (15% off) · cancel anytime.';
        } else { this.renewEl.hidden = true; }
      }

      async addToCart() {
        // Form-encoded on purpose, not JSON: Appstle's "Add JS Interceptor" setting,
        // when enabled, rewrites JSON and FormData /cart/add requests and drops our
        // selling_plan. Appstle turned it off for this store on Oct 30, 2026, but
        // form-encoded keeps the drawer working if it's ever re-enabled. Keep the
        // Appstle app embed on; the rest of the subscription setup relies on it.
        const { mode, qty, sizeId } = this.state;
        if (!sizeId || !qty) return;
        const size = this.SIZES.find((s) => s.id === sizeId);
        const item = { id: this.variantId, quantity: qty, properties: { 'Dog size': size.label } };
        if (mode === 'subscription' && this.plans[qty]) item.selling_plan = this.plans[qty];

        const body = new URLSearchParams();
        body.append('id', item.id);
        body.append('quantity', String(item.quantity));
        if (item.selling_plan) body.append('selling_plan', item.selling_plan);
        body.append('properties[Dog size]', size.label);
        this.addBtn.disabled = true; this.addLabel.textContent = 'Adding…';
        this.addError.hidden = true;
        try {
          const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/javascript' }, body: body });
          const text = await res.text();
          let data = null;
          try { data = JSON.parse(text); } catch (e) {}
          // Surface Shopify's own reason (e.g. a rejected selling plan) instead of a bare "Try again".
          if (!res.ok || !data || data.status) {
            const reason = (data && (data.description || data.message)) || ('HTTP ' + res.status + (text ? ': ' + text.slice(0, 120) : ''));
            console.error('[gpw-buy-drawer] add failed', { status: res.status, mode, qty, item, response: data || text.slice(0, 500) });
            throw new Error(reason);
          }
          if (this.replaceKey) await this.replaceLine(this.replaceKey, data, qty);
          this.close();
          if (document.querySelector('gpw-cart-drawer')) { document.dispatchEvent(new CustomEvent('gpw:cart-added')); }
          else { window.location = this.cartUrl; }
        } catch (err) {
          this.addLabel.textContent = 'Try again';
          this.addError.textContent = err.message || 'Something went wrong adding this to your cart.';
          this.addError.hidden = false;
          this.addBtn.disabled = false;
          console.error('[gpw-buy-drawer]', err);
          return;
        }
        this.renderFooter();
      }

      // Remove the line "Change" was clicked on, now that its replacement is in
      // the cart. If the new pick is identical (same size, plan and jars),
      // Shopify merged it into the old line, so set that line back to qty.
      async replaceLine(oldKey, added, qty) {
        // A form-encoded add returns the line itself; a JSON add returned { items: [line] }.
        const newKey = added && (added.key || (added.items && added.items[0] && added.items[0].key));
        const quantity = newKey === oldKey ? qty : 0;
        try {
          await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: oldKey, quantity: quantity }) });
        } catch (e) { console.error('[gpw-buy-drawer] replace failed', e); }
      }

      setupSticky() {
        if (!this.sticky) return;
        this.sticky.hidden = false;
        this.stickyAnchor = document.querySelector('.pp-buy__cta') || document.querySelector('.pp-hero');
        this.updateSticky = () => {
          if (!this.stickyAnchor) return;
          const past = this.stickyAnchor.getBoundingClientRect().bottom < 0;
          this.sticky.classList.toggle('is-visible', past && !this.classList.contains('is-open'));
        };
        let ticking = false;
        const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(() => { ticking = false; this.updateSticky(); }); } };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        this.updateSticky();
      }
    }
    customElements.define('gpw-buy-drawer', GpwBuyDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gpw-cart-drawer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gpw-cart-drawer')) {
    class GpwCartDrawer extends HTMLElement {
      connectedCallback() {
        this.threshold = parseInt(this.dataset.threshold || '6000', 10);
        this.jar = this.dataset.jar || '';
        this.icons = {};
        this.querySelectorAll('[data-gpw-icons] [data-icon]').forEach((el) => { this.icons[el.dataset.icon] = el.innerHTML; });

        this.scrim = this.querySelector('[data-gpw-cd-scrim]');
        this.drawer = this.querySelector('[data-gpw-cd]');
        this.bodyEl = this.querySelector('[data-gpw-cd-body]');
        this.titleEl = this.querySelector('[data-gpw-cd-title]');
        this.shipWrap = this.querySelector('[data-gpw-cd-ship]');
        this.shipMsg = this.querySelector('[data-gpw-cd-ship-msg]');
        this.shipFill = this.querySelector('[data-gpw-cd-ship-fill]');
        this.footEl = this.querySelector('[data-gpw-cd-foot]');
        this.subtotalEl = this.querySelector('[data-gpw-cd-subtotal]');
        this.subtotalWasEl = this.querySelector('[data-gpw-cd-subtotal-was]');
        this.subtotalRow = this.querySelector('[data-gpw-cd-subtotal-row]');
        this.checkoutBtn = this.querySelector('[data-gpw-cd-checkout]');

        // Quantity changes: latest requested qty per line key, Shopify's refusal
        // reason per line key, and a chain that sends one change at a time.
        this.targets = {};
        this.lineErrors = {};
        this.queue = Promise.resolve();

        this.bodyEl.addEventListener('click', (e) => {
          const btn = e.target.closest('[data-qty-dec], [data-qty-inc], [data-remove], [data-change]');
          if (!btn) return;
          const line = btn.closest('[data-line]');
          const key = line.dataset.line;
          const qty = parseInt(line.dataset.qty, 10);
          if (btn.hasAttribute('data-qty-inc')) this.changeQty(key, qty + 1);
          else if (btn.hasAttribute('data-qty-dec')) this.changeQty(key, qty - 1);
          else if (btn.hasAttribute('data-remove')) this.changeQty(key, 0);
          else if (btn.hasAttribute('data-change')) this.changeLine(e, key);
        });

        this.querySelectorAll('[data-gpw-cd-close]').forEach((b) => b.addEventListener('click', () => this.close()));
        this.scrim.addEventListener('click', () => this.close());
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && this.drawer.classList.contains('is-open')) this.close(); });

        var cartIcon = document.querySelector('#cart-icon-bubble');
        if (cartIcon) cartIcon.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.openCart(false); });

        document.addEventListener('gpw:cart-added', () => this.openCart(true));
      }

      fmt(c) { return '$' + (c / 100).toFixed(2); }

      async openCart(added) {
        try {
          const cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
          this.render(cart, added);
          this.open();
        } catch (e) { console.error('[gpw-cart-drawer]', e); }
      }
      async refresh() {
        const cart = await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();
        this.render(cart, false);
      }

      render(cart, added) {
        this.titleEl.textContent = 'Your Cart — ' + cart.item_count + (cart.item_count === 1 ? ' Item' : ' Items');
        this.updateHeaderCount(cart.item_count);

        if (!cart.items.length) {
          this.bodyEl.innerHTML = '<div class="gpw-cd__empty">Your cart is empty.</div>';
          this.footEl.hidden = true;
          this.shipWrap.hidden = true;
          return;
        }
        this.footEl.hidden = false;
        this.shipWrap.hidden = false;
        this.renderShip(cart);
        this.bodyEl.innerHTML = cart.items.map((it) => this.itemHTML(it)).join('');
        // Pre-discount total. Automatic (line-level) discounts like the one-time
        // volume tiers are captured by original_line_price; subscription selling-
        // plan discounts are NOT counted in total_discount, so use the allocation's
        // compare_at_price for those lines. Whichever applies, show the original
        // struck through with the discounted total emphasized in brand green.
        let originalTotal = 0;
        cart.items.forEach((i) => {
          const spa = i.selling_plan_allocation;
          if (spa && spa.compare_at_price && spa.compare_at_price > spa.price) {
            originalTotal += spa.compare_at_price * i.quantity;
          } else {
            originalTotal += i.original_line_price;
          }
        });
        this.subtotalEl.textContent = this.fmt(cart.total_price);
        if (originalTotal > cart.total_price) {
          this.subtotalWasEl.textContent = this.fmt(originalTotal);
          this.subtotalWasEl.hidden = false;
          this.subtotalRow.classList.add('is-discounted');
        } else {
          this.subtotalWasEl.hidden = true;
          this.subtotalRow.classList.remove('is-discounted');
        }
        this.checkoutBtn.textContent = 'Checkout · ' + this.fmt(cart.total_price);
      }

      // Sub discount % by quantity (Appstle tiers, mirrors the buy drawer).
      subPctByQty(qty) { return qty >= 3 ? 40 : (qty === 2 ? 30 : 20); }
      // One-time volume discount % by total jar quantity (mirrors the buy drawer;
      // applied at checkout by the volume-discount Function).
      volPctByQty(qty) { return qty >= 3 ? 25 : (qty === 2 ? 20 : 0); }

      renderShip(cart) {
        const subItems = cart.items.filter((i) => i.selling_plan_allocation);

        if (subItems.length) {
          // % off from the real selling-plan allocation; fall back to the qty tier.
          let pct = 0;
          subItems.forEach((i) => {
            const spa = i.selling_plan_allocation;
            if (spa && spa.compare_at_price && spa.compare_at_price > spa.price) {
              pct = Math.max(pct, Math.round((1 - spa.price / spa.compare_at_price) * 100));
            }
            pct = Math.max(pct, this.subPctByQty(i.quantity));
          });
          this.shipFill.style.width = '100%';
          this.shipMsg.innerHTML = this.icons.truck + "<span>You've unlocked <strong>" + pct + "% off</strong>, a <strong>FREE gift</strong> &amp; <strong>FREE shipping</strong></span>";
          return;
        }

        // No subscription — one-time. Volume discount by total jar quantity.
        const oneTimeQty = cart.items.reduce((n, i) => n + i.quantity, 0);
        const volPct = this.volPctByQty(oneTimeQty);
        if (volPct > 0) {
          this.shipFill.style.width = '100%';
          this.shipMsg.innerHTML = this.icons.truck + "<span>You've unlocked <strong>" + volPct + "% off</strong> &amp; <strong>FREE Shipping</strong></span>";
          return;
        }

        // Single jar — progress toward the free-shipping threshold.
        const total = cart.total_price;
        const pct = Math.min(100, Math.round((total / this.threshold) * 100));
        this.shipFill.style.width = pct + '%';
        if (total >= this.threshold) {
          this.shipMsg.innerHTML = this.icons.truck + "<span>You've unlocked <strong>FREE shipping</strong></span>";
        } else {
          const remain = (this.threshold - total) / 100;
          this.shipMsg.innerHTML = this.icons.truck + "<span>You're <strong>$" + remain.toFixed(2) + '</strong> away from <strong>FREE shipping</strong></span>';
        }
      }

      itemHTML(it) {
        const size = it.properties && it.properties['Dog size'] ? it.properties['Dog size'] : null;
        const sub = it.selling_plan_allocation ? 'Subscribe (every 60 days)' : 'One-time';
        const meta = [size, sub].filter(Boolean).join(' · ');
        // Original (pre-discount) line price + savings %. Subscriptions carry
        // their discount in the selling-plan allocation (compare_at_price);
        // one-time lines carry automatic discounts in original_line_price.
        const spa = it.selling_plan_allocation;
        let origLine = it.original_line_price;
        if (spa && spa.compare_at_price && spa.compare_at_price > spa.price) {
          origLine = spa.compare_at_price * it.quantity;
        }
        const saved = origLine > it.final_line_price ? Math.round((1 - it.final_line_price / origLine) * 100) : 0;
        const img = this.jar;
        const title = it.product_title || it.title;
        // One-time lines get the −/+ stepper (qty lives there, not in the title).
        // Subscription lines keep qty as text and get "Change", which reopens the
        // buy drawer; selling plans are never edited from the cart.
        const control = spa
          ? '<a class="gpw-cd__change" data-change href="' + this.changeUrl(it) + '">Change</a>'
          : '<div class="gpw-cd__qty" role="group" aria-label="Quantity">' +
              '<button type="button" class="gpw-cd__qty-btn" data-qty-dec aria-label="Decrease quantity">−</button>' +
              '<span class="gpw-cd__qty-val" aria-live="polite">' + it.quantity + '</span>' +
              '<button type="button" class="gpw-cd__qty-btn" data-qty-inc aria-label="Increase quantity">+</button>' +
            '</div>';
        const err = this.lineErrors[it.key];
        return '<div class="gpw-cd__item" data-line="' + it.key + '" data-qty="' + it.quantity + '">' +
          '<div class="gpw-cd__thumb"><img src="' + img + '" alt="" loading="lazy"></div>' +
          '<div class="gpw-cd__item-main">' +
            '<div class="gpw-cd__item-title">' + title + (spa ? ' × ' + it.quantity : '') + '</div>' +
            (meta ? '<div class="gpw-cd__item-meta">' + meta + '</div>' : '') +
            (saved > 0 ? '<span class="gpw-cd__saved">Saved ' + saved + '%</span>' : '') +
            '<div>' + control + '</div>' +
            (err ? '<p class="gpw-cd__line-error" role="alert">' + this.esc(err) + '</p>' : '') +
          '</div>' +
          '<div class="gpw-cd__item-r">' +
            '<div class="gpw-cd__item-price">' +
              (saved > 0 ? '<s class="gpw-cd__item-was">' + this.fmt(origLine) + '</s>' : '') +
              '<span class="gpw-cd__item-now' + (saved > 0 ? ' is-discounted' : '') + '">' + this.fmt(it.final_line_price) + '</span>' +
            '</div>' +
            '<button type="button" class="gpw-cd__remove" data-remove>Remove</button>' +
          '</div>' +
        '</div>';
      }

      esc(s) { return String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]); }

      // Set a line's quantity (0 = remove). The line updates on screen at once;
      // the request joins a queue so rapid clicks never overlap, and only the
      // latest requested qty per line is sent.
      changeQty(key, qty) {
        qty = Math.max(0, qty);
        delete this.lineErrors[key];
        const line = this.bodyEl.querySelector('[data-line="' + CSS.escape(key) + '"]');
        if (line) {
          const errEl = line.querySelector('.gpw-cd__line-error');
          if (errEl) errEl.remove();
          if (qty === 0) {
            line.classList.add('is-removing');
            setTimeout(() => { if (line.isConnected) line.hidden = true; }, 200);
          } else {
            line.dataset.qty = qty;
            const val = line.querySelector('.gpw-cd__qty-val');
            if (val) val.textContent = qty;
          }
        }
        this.targets[key] = qty;
        this.drawer.classList.add('is-busy');
        this.queue = this.queue.then(() => this.sendQty(key)).catch((e) => console.error('[gpw-cart-drawer]', e));
      }

      async sendQty(key) {
        if (!(key in this.targets)) return; // a later click already sent it
        const qty = this.targets[key];
        delete this.targets[key];
        let cart = null;
        try {
          const res = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
          const text = await res.text();
          let data = null;
          try { data = JSON.parse(text); } catch (e) {}
          if (res.ok && data && !data.status) {
            cart = data; // change.js returns the full updated cart: no second fetch
          } else {
            // Show Shopify's own reason (e.g. not enough stock) under the line.
            this.lineErrors[key] = (data && (data.description || data.message)) || 'This change could not be saved.';
            console.error('[gpw-cart-drawer] change failed', { status: res.status, key, qty, response: data || text.slice(0, 500) });
          }
        } catch (e) {
          this.lineErrors[key] = 'This change could not be saved.';
          console.error('[gpw-cart-drawer]', e);
        }
        if (Object.keys(this.targets).length) return; // more changes queued: render after the last
        this.drawer.classList.remove('is-busy');
        if (cart) this.render(cart, false);
        else this.refresh(); // restore the real state after a refused change
      }

      // Subscription "Change": hand the line to the buy drawer, which swaps it
      // for the customer's new pick. Off the product page, the link's href
      // goes there with the drawer open instead.
      changeUrl(it) {
        const u = new URL(it.url, window.location.origin);
        u.searchParams.set('buy', 'open');
        u.searchParams.set('replace', it.key);
        return this.esc(u.pathname + u.search);
      }
      changeLine(e, key) {
        const buy = document.querySelector('gpw-buy-drawer');
        if (!buy || typeof buy.openForChange !== 'function') return;
        e.preventDefault();
        this.close();
        buy.openForChange(key);
      }

      updateHeaderCount(n) {
        const icon = document.querySelector('#cart-icon-bubble');
        if (!icon) return;
        let sup = icon.querySelector('.gpw-nav__cart-count');
        if (n > 0) {
          if (!sup) {
            sup = document.createElement('sup');
            sup.className = 'gpw-nav__cart-count';
            sup.setAttribute('aria-hidden', 'true');
            const hidden = icon.querySelector('.visually-hidden');
            hidden ? icon.insertBefore(sup, hidden) : icon.appendChild(sup);
          }
          sup.textContent = n;
        } else if (sup) { sup.remove(); }
      }

      open() {
        this.scrim.hidden = false; requestAnimationFrame(() => this.scrim.classList.add('is-open'));
        this.drawer.classList.add('is-open'); this.drawer.inert = false; this.drawer.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';
      }
      close() {
        this.scrim.classList.remove('is-open'); this.drawer.classList.remove('is-open');
        // Closed drawer is inert so its off-canvas controls never take keyboard focus.
        this.drawer.inert = true; this.drawer.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        setTimeout(() => { if (!this.drawer.classList.contains('is-open')) this.scrim.hidden = true; }, 320);
      }
    }
    customElements.define('gpw-cart-drawer', GpwCartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gpw-contact"] && !Shopify.designMode) return;
  try {
    
(function () {
  var form = document.getElementById('gpwContactForm');
  if (!form) return;
  var fields = [
    { id: 'ct-name', err: 'ct-err-name', msg: 'Please enter your name.' },
    { id: 'ct-email', err: 'ct-err-email', msg: 'Please enter your email.', email: true },
    { id: 'ct-message', err: 'ct-err-message', msg: 'Please enter a message.' }
  ];
  function setErr(f, show) {
    var el = document.getElementById(f.id), e = document.getElementById(f.err);
    if (!el || !e) return;
    if (show) { e.textContent = f.text || f.msg; e.classList.add('show'); el.setAttribute('aria-invalid', 'true'); el.setAttribute('aria-describedby', f.err); }
    else { e.textContent = ''; e.classList.remove('show'); el.removeAttribute('aria-invalid'); el.removeAttribute('aria-describedby'); }
  }
  form.addEventListener('submit', function (ev) {
    var firstBad = null;
    fields.forEach(function (f) {
      var el = document.getElementById(f.id), v = (el.value || '').trim(), bad = false;
      if (!v) { bad = true; f.text = f.msg; }
      else if (f.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) { bad = true; f.text = 'Please enter a valid email.'; }
      setErr(f, bad);
      if (bad && !firstBad) firstBad = el;
    });
    if (firstBad) { ev.preventDefault(); firstBad.focus(); }
  });
  fields.forEach(function (f) {
    var el = document.getElementById(f.id);
    if (!el) return;
    el.addEventListener('input', function () { if (el.getAttribute('aria-invalid') === 'true') setErr(f, false); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gpw-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var root = document.querySelector('.gpw-faq');
      if (!root) return;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function targetFor(hash) {
        if (!hash || hash.length < 2) return null;
        var id = hash.charAt(0) === '#' ? hash.slice(1) : hash;
        return document.getElementById(id);
      }
      function openFromHash() {
        var el = targetFor(window.location.hash);
        if (!el) return;
        if (el.tagName === 'DETAILS') el.open = true;
        el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }

      window.addEventListener('hashchange', openFromHash);
      openFromHash();
      // Fallback: re-run after full load in case the section DOM mounted after this ran.
      window.addEventListener('load', openFromHash);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gpw-header"]) return;
  try {
    
  if (!customElements.get('gpw-header')) {
    class GpwHeader extends HTMLElement {
      connectedCallback() {
        // Hysteresis: engage well past the threshold, release well before it, so
        // scrolling slowly (or trackpad wobble) can't flip the class repeatedly.
        const mid = parseInt(this.getAttribute('data-scroll-threshold'), 10) || 40;
        const engageAt = mid + 24;
        const releaseAt = Math.max(4, mid - 16);
        let scrolled = false;
        let ticking = false;
        const apply = () => {
          ticking = false;
          const y = window.scrollY;
          if (!scrolled && y > engageAt) { scrolled = true; this.classList.add('is-scrolled'); }
          else if (scrolled && y < releaseAt) { scrolled = false; this.classList.remove('is-scrolled'); }
        };
        // Coalesce to one write per frame instead of one per scroll event.
        this._onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(apply); } };
        window.addEventListener('scroll', this._onScroll, { passive: true });
        scrolled = window.scrollY > engageAt;
        this.classList.toggle('is-scrolled', scrolled);

        const burger = this.querySelector('.gpw-nav__burger');
        const menu = document.getElementById('gpw-mobile-menu');
        const scrim = document.querySelector('.gpw-mm-scrim');
        if (!burger || !menu || !scrim) return;

        const closeBtn = menu.querySelector('[data-gpw-mm-close]');
        const open = () => {
          menu.classList.add('is-open'); scrim.classList.add('is-open');
          menu.inert = false; menu.setAttribute('aria-hidden', 'false'); burger.setAttribute('aria-expanded', 'true');
          document.body.style.overflow = 'hidden';
        };
        const close = () => {
          menu.classList.remove('is-open'); scrim.classList.remove('is-open');
          // Closed menu is inert so its off-canvas links never take keyboard focus.
          menu.inert = true; menu.setAttribute('aria-hidden', 'true'); burger.setAttribute('aria-expanded', 'false');
          document.body.style.overflow = '';
        };
        burger.addEventListener('click', open);
        if (closeBtn) closeBtn.addEventListener('click', close);
        scrim.addEventListener('click', close);
        menu.querySelectorAll('a').forEach((a) => a.addEventListener('click', close));
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
      }
      disconnectedCallback() { window.removeEventListener('scroll', this._onScroll); }
    }
    customElements.define('gpw-header', GpwHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gpw-hub-article"]) return;
  try {
    
(function () {
  var hub = document.querySelector('.gpw-hub');
  if (!hub) return;
  var content = hub.querySelector('.content');
  if (!content) return;
  var heads = content.querySelectorAll(':scope > h2, :scope > .reading > h2');
  if (!heads.length) return;

  function slug(s) {
    return s.toLowerCase().replace(/[^\w\s-]/g, '').trim().replace(/\s+/g, '-').slice(0, 60) || 'section';
  }
  var used = {};
  var items = [];
  Array.prototype.forEach.call(heads, function (h) {
    var id = h.id;
    if (!id) {
      id = slug(h.textContent);
      while (used[id]) { id = id + '-x'; }
      h.id = id;
    }
    used[id] = true;
    items.push({ id: id, text: h.textContent.trim() });
  });
  if (!items.length) return;

  hub.querySelectorAll('[data-gpw-toc-list]').forEach(function (ol) {
    ol.innerHTML = items.map(function (it) {
      return '<li><a href="#' + it.id + '">' + it.text.replace(/&/g, '&amp;').replace(/</g, '&lt;') + '</a></li>';
    }).join('');
  });
  var side = hub.querySelector('[data-gpw-toc-side]');
  var inline = hub.querySelector('[data-gpw-toc-inline]');
  if (side) side.hidden = false;
  if (inline) inline.hidden = false;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gpw-inside"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gpw-ribbon')) {
    class GpwRibbon extends HTMLElement {
      connectedCallback() {
        var ribbon = this;
        var track = this.querySelector('[data-ribbon-track]');
        if (!track) return;
        var label = this.querySelector('[data-ribbon-label]');
        var originals = Array.prototype.slice.call(track.children);
        var count = originals.length;
        if (!count) return;
        originals.forEach(function (el) { track.appendChild(el.cloneNode(true)); });
        originals.forEach(function (el) { track.appendChild(el.cloneNode(true)); });
        var cells = Array.prototype.slice.call(track.children);
        var VISIBLE = 5, BIG = 1.18, SMALL = 0.78, OP_MIN = 0.34, START = 4, DUR = 820;
        var gap = 0, cellW = 0, stride = 0, W = 0, step = START;
        var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        function layout() {
          W = ribbon.clientWidth;
          var V = (W <= 600) ? 3 : VISIBLE;
          gap = Math.max(20, Math.min(40, W * 0.026));
          cellW = (W - gap * (V - 1)) / V;
          stride = cellW + gap;
          track.style.gap = gap + 'px';
          cells.forEach(function (c) { c.style.flex = '0 0 ' + cellW + 'px'; c.style.width = cellW + 'px'; });
        }
        function setTransition(on) {
          track.style.transition = on ? '' : 'none';
          for (var i = 0; i < cells.length; i++) cells[i].style.transition = on ? '' : 'none';
        }
        function render() {
          var x = -step * stride;
          track.style.transform = 'translate3d(' + x + 'px,0,0)';
          var sigma = stride * 1.15;
          var szF = (W <= 600) ? 1 : 0.75;
          var best = -1, bestG = -1;
          for (var i = 0; i < cells.length; i++) {
            var cx = x + i * stride + cellW / 2;
            var d = cx - W / 2;
            var g = Math.exp(-(d * d) / (2 * sigma * sigma));
            var s = (SMALL + (BIG - SMALL) * g) * szF * (0.85 + 0.15 * Math.pow(g, 6));
            cells[i].style.transform = 'scale(' + s.toFixed(3) + ')';
            cells[i].style.opacity = (OP_MIN + (1 - OP_MIN) * g).toFixed(3);
            cells[i].style.zIndex = Math.round(s * 100);
            if (g > bestG) { bestG = g; best = i; }
          }
          if (label && best >= 0) label.textContent = cells[best].getAttribute('data-name') || '';
        }
        function snap() { setTransition(false); render(); track.getBoundingClientRect(); setTransition(true); }
        var timer = null;
        function tick() {
          step++; render();
          if (step >= START + count) {
            window.setTimeout(function () { step = START; snap(); }, DUR + 20);
          }
        }
        function start() { if (reduced || timer) return; timer = window.setInterval(tick, 2000); }
        function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
        layout(); snap();
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (e) { if (e.isIntersecting) start(); else stop(); });
          }, { threshold: 0.08 }).observe(ribbon);
        } else { start(); }
        var rt;
        window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { layout(); snap(); }, 150); });
      }
    }
    customElements.define('gpw-ribbon', GpwRibbon);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gpw-land-article"]) return;
  try {
    
(function () {
  var root = document.querySelector('.gpw-land');
  if (!root) return;
  var box = root.querySelector('[data-gpw-buybox]');

  // ---- Buy box: pricing + selection (mirrors the PDP buy drawer tiers) ----
  var PRICING = { subscription: { 1: 3920, 2: 6860, 3: 8820 }, onetime: { 1: 4900, 2: 7840, 3: 11025 } };
  var PER = { subscription: 'every 60 days', onetime: 'one-time' };
  var mode = 'subscription', qty = 1;
  function fmt(c) { return '$' + (c / 100).toFixed(2); }
  function total(m, q) { var map = PRICING[m]; return q <= 3 ? map[q] : Math.round(map[3] / 3 * q); }
  var priceEl = box && box.querySelector('[data-gpw-bb-price]');
  var perEl = box && box.querySelector('[data-gpw-bb-per]');
  var qnEl = box && box.querySelector('[data-gpw-bb-qn]');
  function renderPrice() {
    if (priceEl) priceEl.textContent = fmt(total(mode, qty));
    if (perEl) perEl.textContent = PER[mode];
  }

  root.querySelectorAll('.opt input').forEach(function (inp) {
    inp.addEventListener('change', function () {
      root.querySelectorAll('.opt').forEach(function (o) { o.classList.remove('sel'); });
      inp.closest('.opt').classList.add('sel');
      mode = inp.value === 'onetime' ? 'onetime' : 'subscription';
      renderPrice();
    });
  });
  var qbtns = box ? box.querySelectorAll('.qc button') : [];
  if (qnEl && qbtns.length) {
    qbtns[0].onclick = function () { qty = Math.max(1, qty - 1); qnEl.textContent = qty; renderPrice(); };
    qbtns[1].onclick = function () { qty++; qnEl.textContent = qty; renderPrice(); };
  }
  renderPrice();

  // add to cart → /cart/add.js → open the site-wide cart drawer
  var addBtn = box && box.querySelector('[data-gpw-bb-add]');
  if (box && addBtn && box.dataset.variant) {
    var variantId = box.dataset.variant;
    var plans = { 1: box.dataset.plan1, 2: box.dataset.plan2, 3: box.dataset.plan3 };
    addBtn.addEventListener('click', function () {
      var item = { id: variantId, quantity: qty };
      if (mode === 'subscription') { var p = plans[Math.min(qty, 3)]; if (p) item.selling_plan = p; }
      var orig = addBtn.innerHTML;
      addBtn.disabled = true; addBtn.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' }, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { return r.json(); })
        .then(function () {
          addBtn.disabled = false; addBtn.innerHTML = orig;
          if (document.querySelector('gpw-cart-drawer')) document.dispatchEvent(new CustomEvent('gpw:cart-added'));
        })
        .catch(function (e) { console.error('[gpw-land buybox]', e); addBtn.disabled = false; addBtn.innerHTML = orig; });
    });
  }

  // ---- Sticky CTA: show after hero, hide when buy box or final CTA on screen ----
  var sticky = root.querySelector('[data-gpw-sticky]');
  var hero = root.querySelector('.hero');
  var buybox = root.querySelector('#buybox');
  var final = root.querySelector('.final');
  if (sticky && hero && buybox && final) {
    var upd = function () {
      var pastHero = hero.getBoundingClientRect().bottom < 0;
      var bb = buybox.getBoundingClientRect();
      var fr = final.getBoundingClientRect();
      var vh = window.innerHeight;
      var bbVisible = bb.top < vh && bb.bottom > 0;
      var fVisible = fr.top < vh && fr.bottom > 0;
      if (pastHero && !bbVisible && !fVisible) sticky.classList.add('show');
      else sticky.classList.remove('show');
    };
    window.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gpw-mystery-discount-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gpw-mystery-popup')) {
    class GpwMysteryPopup extends HTMLElement {
      connectedCallback() {
        if (this.dataset.wired) return;          // never initialise twice
        this.dataset.wired = '1';

        this.KEY_SUB = 'gpw_mystery_popup_subscribed';
        this.KEY_DIS = 'gpw_mystery_popup_dismissed_at';
        this.KEY_SES = 'gpw_mystery_popup_seen_session';
        this.KEY_KNOWN = 'gpw_mystery_popup_known';      // we already have their email
        this.KEY_PEND = 'gpw_mystery_popup_pending';     // sessionStorage: fallback signup in flight

        this.endpoint = this.dataset.endpoint || '';
        this.scrollPct = parseInt(this.dataset.scrollPct, 10) || 30;
        this.dismissDays = parseInt(this.dataset.dismissDays, 10) || 7;
        this.useExitIntent = this.dataset.exitIntent === '1';

        this.dialog = this.querySelector('[data-mdp-dialog]');
        this.scrim = this.querySelector('[data-mdp-scrim]');
        if (!this.dialog || !this.scrim) return;

        this.state = { dogSize: null, step: 1, open: false };
        const params = new URLSearchParams(location.search);
        this.designMode = !!(window.Shopify && window.Shopify.designMode);
        this.forced = params.has('gpw_popup');

        // Preview-only step override (?gpw_popup=1&gpw_popup_step=3). Strictly visual:
        // it never submits, never marks the visitor subscribed and never writes
        // suppression. Gated behind `forced`, so without gpw_popup=1 it cannot be
        // reached at all — a normal visitor has no path to it.
        this.previewStep = 0;
        if (this.forced) {
          const s = parseInt(params.get('gpw_popup_step'), 10);
          if (s === 1 || s === 2 || s === 3) this.previewStep = s;
        }

        // Back from the same-site fallback signup (see fallbackSubmit). Checked before
        // suppression: customer_posted=true would otherwise mark the visitor as known
        // and keep the popup closed before it could show their code.
        // Shopify's spam-check page (/challenge) also loads the theme: stay out of the
        // way there and leave the flag for the page the visitor lands on afterwards.
        if (/^\/challenge/.test(location.pathname)) return;
        const pending = this.takePending();
        const posted = params.get('customer_posted') === 'true';
        if (pending && (posted || location.pathname === '/contact')) {
          this.bind();
          this.resumeFallback(pending, posted);
          return;
        }

        if (!this.forced && !this.canShow()) return;
        this.bind();
        if (this.forced) {
          this.open();
          if (this.previewStep > 1) this.go(this.previewStep);
          return;
        }
        if (this.designMode) return;             // never auto-open in the editor
        this.armTriggers();
      }

      /* ---------- storage (guarded: Safari private mode throws) ---------- */
      get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
      set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }

      canShow() {
        if (this.get(this.KEY_SUB)) return false;                       // signed up: forever
        if (this.get(this.KEY_KNOWN)) return false;                     // known contact: forever
        if (this.isKnownContact()) { this.set(this.KEY_KNOWN, '1'); return false; }
        const at = parseInt(this.get(this.KEY_DIS) || '0', 10);
        if (at && Date.now() - at < this.dismissDays * 864e5) return false;  // dismissed: N days
        try { if (window.sessionStorage.getItem(this.KEY_SES)) return false; } catch (e) {}
        return true;
      }

      // Visitors whose email we already have. Remembered in this browser once seen,
      // so they stay suppressed after the signal itself is gone.
      isKnownContact() {
        if (this.dataset.customer === '1') return true;              // logged in to a store account
        // Omnisend's own 1-year cookie, set once it has matched this browser to a contact
        // (clicked an Omnisend email/SMS, signed up through Omnisend, or a logged-in customer).
        if (/(?:^|;\s*)omnisendContactID=[^;\s]/.test(document.cookie)) return true;
        const q = new URLSearchParams(location.search);
        if (q.get('omnisendContactID')) return true;                 // arrived from an Omnisend email/SMS link
        if (q.get('customer_posted') === 'true') return true;        // just joined via the footer newsletter
        return false;
      }

      /* ---------- analytics: CustomEvent + dataLayer, no libraries ---------- */
      track(name, props) {
        const detail = Object.assign({}, props || {});
        try { window.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) {}
        if (window.dataLayer && typeof window.dataLayer.push === 'function') {
          window.dataLayer.push(Object.assign({ event: name }, detail));
        }
      }

      /* ---------- triggers: 30% scroll OR desktop exit intent ---------- */
      armTriggers() {
        let ticking = false;
        this._onScroll = () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            ticking = false;
            const doc = document.documentElement;
            const max = doc.scrollHeight - window.innerHeight;
            if (max > 0 && (window.scrollY / max) * 100 >= this.scrollPct) this.open();
          });
        };
        window.addEventListener('scroll', this._onScroll, { passive: true });

        // Desktop only, and only for real pointers, so phones never see fake exit intent.
        const pointerOk = window.matchMedia('(min-width: 750px) and (hover: hover) and (pointer: fine)').matches;
        if (this.useExitIntent && pointerOk) {
          this._onExit = (e) => {
            // Conservative: only a true exit through the top edge of the document.
            if (e.relatedTarget || e.toElement) return;   // still inside the page
            if (e.clientY > 4) return;                    // not the top edge
            this.open();
          };
          document.addEventListener('mouseout', this._onExit);
        }
      }

      disarm() {
        if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
        if (this._onExit) document.removeEventListener('mouseout', this._onExit);
        this._onScroll = this._onExit = null;
      }

      /* ---------- wiring ---------- */
      bind() {
        this.querySelector('[data-mdp-close]').addEventListener('click', () => this.close('x'));
        this.scrim.addEventListener('click', () => this.close('scrim'));

        this.querySelectorAll('[data-mdp-size]').forEach((btn) => {
          btn.addEventListener('click', () => this.pickSize(btn));
        });

        const form = this.querySelector('[data-mdp-form]');
        if (form) form.addEventListener('submit', (e) => { e.preventDefault(); this.submit(); });

        const one = this.querySelector('[data-mdp-onetime]');
        if (one) one.addEventListener('click', () => this.track('gpw_popup_onetime_clicked', { dog_size: this.state.dogSize }));
        // Retained deliberately: Step 3 no longer has a subscribe CTA, so this is
        // inert. Left in place so analytics wiring is unchanged if a CTA returns.
        const sub = this.querySelector('[data-mdp-sub]');
        if (sub) sub.addEventListener('click', () => this.track('gpw_popup_subscription_clicked', { dog_size: this.state.dogSize }));

        this._onKey = (e) => {
          if (!this.state.open) return;
          if (e.key === 'Escape') { this.close('escape'); return; }
          if (e.key === 'Tab') this.trapFocus(e);
        };
        document.addEventListener('keydown', this._onKey);
      }

      /* ---------- focus management ---------- */
      focusables() {
        return Array.prototype.slice.call(this.dialog.querySelectorAll(
          'button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter((el) => el.offsetParent !== null);
      }

      trapFocus(e) {
        const f = this.focusables();
        if (!f.length) return;
        const first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }

      /* ---------- open / close ---------- */
      open() {
        if (this.state.open) return;
        this.disarm();                                  // once per page load
        this.state.open = true;
        // A forced preview must leave suppression state exactly as it found it.
        if (!this.forced) { try { window.sessionStorage.setItem(this.KEY_SES, '1'); } catch (e) {} }

        this.lastFocus = document.activeElement;
        this.scrim.hidden = false;
        this.dialog.hidden = false;
        requestAnimationFrame(() => {
          this.scrim.classList.add('is-open');
          this.dialog.classList.add('is-open');
        });
        this.dialog.setAttribute('aria-hidden', 'false');
        document.documentElement.style.overflow = 'hidden';

        // Focus the dialog itself, not the X. Focusing a button programmatically
        // trips :focus-visible and Dawn's global outline+box-shadow ring, which is
        // why step 1's close button looked different from step 2's.
        this.dialog.focus();
        this.track('gpw_popup_viewed');
      }

      close(reason) {
        if (!this.state.open) return;
        this.state.open = false;
        this.scrim.classList.remove('is-open');
        this.dialog.classList.remove('is-open');
        this.dialog.setAttribute('aria-hidden', 'true');
        document.documentElement.style.overflow = '';
        setTimeout(() => {
          if (!this.state.open) { this.scrim.hidden = true; this.dialog.hidden = true; }
        }, 240);

        // Only a real dismissal starts the 7-day clock; closing after signing up
        // is already covered by the permanent flag.
        if (!this.forced && reason !== 'converted' && !this.get(this.KEY_SUB)) {
          this.set(this.KEY_DIS, String(Date.now()));
        }
        this.track('gpw_popup_closed', { step: this.state.step });
        if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
      }

      /* ---------- steps ---------- */
      go(step) {
        this.state.step = step;
        this.querySelectorAll('[data-mdp-step]').forEach((el) => {
          el.hidden = parseInt(el.getAttribute('data-mdp-step'), 10) !== step;
        });
        this.dialog.focus();
      }

      pickSize(btn) {
        this.state.dogSize = btn.getAttribute('data-mdp-size');
        this.querySelectorAll('[data-mdp-size]').forEach((b) => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        this.track('gpw_popup_dog_selected', { dog_size: this.state.dogSize });

        // Brief orange confirmation, then advance. No Continue button.
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        setTimeout(() => { this.go(2); this.track('gpw_popup_email_step'); }, reduced ? 0 : 260);
      }

      showError(msg) {
        const el = this.querySelector('[data-mdp-error]');
        const input = this.querySelector('[data-mdp-email]');
        if (el) { el.textContent = msg; el.hidden = false; }
        if (input) input.classList.add('has-error');
      }

      clearError() {
        const el = this.querySelector('[data-mdp-error]');
        const input = this.querySelector('[data-mdp-email]');
        if (el) el.hidden = true;
        if (input) input.classList.remove('has-error');
      }

      async submit() {
        const input = this.querySelector('[data-mdp-email]');
        const btn = this.querySelector('[data-mdp-submit]');
        const email = (input.value || '').trim();
        this.clearError();

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
          this.showError('Please enter a valid email address.');
          input.focus();
          return;
        }

        // No endpoint configured: never silently "succeed" for a real visitor.
        if (!this.endpoint) {
          if (this.designMode) {
            console.warn('[GPW popup] No signup endpoint configured. Set it in the theme editor: Mystery discount popup > Secure signup endpoint URL. Simulating success for preview only.');
            this.succeed();                           // editor preview of step 3
          } else {
            this.showError('Something went wrong. Please try again.');
          }
          return;
        }

        btn.disabled = true;
        const label = this.querySelector('[data-mdp-submit-label]');
        const original = label ? label.textContent : '';
        if (label) label.textContent = 'Submitting...';

        // 1) /apps/gpw (app proxy -> signup function): writes the dog size and
        //    popup tags straight to Omnisend.
        let ok = false;
        const ctl = typeof AbortController === 'function' ? new AbortController() : null;
        const timer = ctl ? setTimeout(() => ctl.abort(), 6000) : 0;
        try {
          const res = await fetch(this.endpoint, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              email: email,
              dog_size: this.state.dogSize,
              source: 'gpw_mystery_discount_popup'
            }),
            signal: ctl ? ctl.signal : undefined
          });
          if (res.ok) {
            // Through the app proxy Shopify can answer with an HTML page (app
            // uninstalled, route missing), so only a JSON { ok: true } counts.
            const data = await res.json().catch(() => null);
            ok = !!(data && data.ok === true);
          }
        } catch (err) {
          // Network-level failure (blocked, untrusted certificate, offline, timeout).
        }
        clearTimeout(timer);

        // Outside the try, so a problem after a successful signup can never show
        // the failure message.
        if (ok) { this.succeed(); return; }

        // 2) Same-site fallback: Shopify's newsletter signup on this domain. The page
        //    navigates, and resumeFallback() shows the code when it comes back.
        if (this.fallbackSubmit(email)) return;

        // Keep the email and the dog size; only restore the button.
        this.showError('We could not sign you up just now. Please try again.');
        btn.disabled = false;
        if (label) label.textContent = original;
      }

      /* ---------- same-site fallback signup ---------- */
      fallbackSubmit(email) {
        const form = this.querySelector('#gpw-mdp-fallback');
        const field = form && form.querySelector('[data-mdp-fallback-email]');
        if (!field) return false;
        // Without this flag the returning page could not show the code, so if
        // storage is unavailable, report the failure instead.
        try {
          window.sessionStorage.setItem(this.KEY_PEND, JSON.stringify({ dog: this.state.dogSize, t: Date.now() }));
        } catch (e) { return false; }

        field.value = email;
        const tags = form.querySelector('[data-mdp-fallback-tags]');
        if (tags && this.state.dogSize && tags.value.indexOf('dog_size:') === -1) {
          tags.value += ', dog_size: ' + this.state.dogSize;
        }
        this.track('gpw_popup_fallback_signup', { dog_size: this.state.dogSize });

        // Shopify's spam protection holds every newsletter form's submit until its
        // hCaptcha is attached, which normally happens when a visitor clicks into the
        // form. Nobody clicks into this hidden one, so attach it through Shopify's own
        // API, then submit through it exactly as the footer form does.
        let sent = false;
        const send = (viaCaptcha) => {
          if (sent) return;
          sent = true;
          if (viaCaptcha && typeof form.requestSubmit === 'function') form.requestSubmit();
          else form.submit();          // plain post; Shopify shows its own challenge page if it wants one
        };
        const cap = window.Shopify && window.Shopify.captcha;
        if (cap && typeof cap.protect === 'function') {
          try { cap.protect(form, () => send(true)); } catch (e) { send(false); }
          setTimeout(() => send(false), 5000);   // captcha script never loaded
        } else {
          send(false);
        }
        return true;
      }

      takePending() {
        let p = null;
        try {
          const raw = window.sessionStorage.getItem(this.KEY_PEND);
          if (raw) { window.sessionStorage.removeItem(this.KEY_PEND); p = JSON.parse(raw); }
        } catch (e) { return null; }
        if (!p || typeof p.t !== 'number' || Date.now() - p.t > 15 * 60 * 1000) return null;
        return p;
      }

      resumeFallback(p, posted) {
        this.state.dogSize = ['small', 'medium', 'large'].indexOf(p.dog) > -1 ? p.dog : null;
        this.open();
        if (posted) {
          this.succeed({ method: 'shopify_form' });
        } else {
          // Shopify rejected the address (it re-renders with form errors instead).
          this.go(2);
          this.showError('Please enter a valid email address.');
        }
      }

      succeed(extra) {
        const props = Object.assign({ dog_size: this.state.dogSize }, extra || {});
        this.set(this.KEY_SUB, '1');                 // suppress permanently in this browser
        this.track('gpw_popup_submitted', props);
        this.go(3);
        this.track('gpw_popup_offer_revealed', props);
      }

      disconnectedCallback() {
        this.disarm();
        if (this._onKey) document.removeEventListener('keydown', this._onKey);
      }
    }
    customElements.define('gpw-mystery-popup', GpwMysteryPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gpw-pdp-anchornav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var wrap = document.querySelector('[data-pdp-anchornav]');
      if (!wrap || wrap.dataset.wired) return;
      wrap.dataset.wired = '1';

      var nav = wrap.querySelector('.ppnav');
      var row = wrap.querySelector('.ppnav__row');
      var links = Array.prototype.slice.call(wrap.querySelectorAll('.ppnav__link'));
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

      /* Product page only: let the shared header flow off screen solidly — turn
         off its glass "is-scrolled" shrink (this code runs only where the nav
         exists, i.e. the product template; the header file itself is untouched). */
      var header = document.querySelector('.gpw-nav');
      if (header) { try { header.threshold = Infinity; } catch (e) {} header.classList.remove('is-scrolled'); }

      /* --- Scroll-spy via IntersectionObserver --- */
      var targets = links.map(function (l) { return document.getElementById(l.getAttribute('data-spy')); }).filter(Boolean);
      var order = targets.map(function (t) { return t.id; });
      var inView = {};
      var current = null;
      var spyLock = false, spyTimer;

      function centerLink(l) {
        var lr = l.getBoundingClientRect(), rr = row.getBoundingClientRect();
        if (lr.left < rr.left + 4 || lr.right > rr.right - 4) {
          var to = l.offsetLeft - (row.clientWidth - l.offsetWidth) / 2;
          row.scrollTo({ left: Math.max(0, to), behavior: reduce.matches ? 'auto' : 'smooth' });
        }
      }
      function setActive(id) {
        if (id === current) return;
        current = id;
        links.forEach(function (l) {
          var on = l.getAttribute('data-spy') === id;
          if (on) { l.setAttribute('aria-current', 'true'); centerLink(l); }
          else l.removeAttribute('aria-current');
        });
      }
      setActive('pp-overview'); /* default active on load */

      var ioTop = (nav ? nav.offsetHeight : 47) + 24;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) inView[e.target.id] = true; else delete inView[e.target.id];
        });
        if (spyLock) return; /* don't fight a click-driven scroll */
        for (var i = 0; i < order.length; i++) {
          if (inView[order[i]]) { setActive(order[i]); return; }
        }
        /* nothing in the band: keep the current active link */
      }, { rootMargin: '-' + ioTop + 'px 0px -55% 0px', threshold: 0 });
      targets.forEach(function (t) { io.observe(t); });

      /* --- Smooth-scroll on click (respects scroll-margin-top) --- */
      links.forEach(function (l) {
        l.addEventListener('click', function (e) {
          var id = l.getAttribute('data-spy');
          var t = document.getElementById(id);
          if (!t) return;
          e.preventDefault();
          spyLock = true; clearTimeout(spyTimer);
          spyTimer = setTimeout(function () { spyLock = false; }, 750);
          var behavior = reduce.matches ? 'auto' : 'smooth';
          if (id === 'pp-overview') window.scrollTo({ top: 0, behavior: behavior }); /* Overview -> top of page */
          else t.scrollIntoView({ behavior: behavior, block: 'start' });
          setActive(id);
          if (history.replaceState) { try { history.replaceState(null, '', '#' + id); } catch (err) {} }
        });
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', function (e) {
      if (e.target && e.target.querySelector && e.target.querySelector('[data-pdp-anchornav]')) init();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gpw-pdp-comparison"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gpw-compare')) {
    class GpwCompare extends HTMLElement {
      connectedCallback() {
        var grid = this.querySelector('[data-gpw-grid]');
        if (!grid) return;
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce || !('IntersectionObserver' in window)) {
          grid.classList.add('is-revealed');
          return;
        }
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              grid.classList.add('is-revealed');
              io.disconnect();
            }
          });
        }, { threshold: 0.2 });
        io.observe(grid);
      }
    }
    customElements.define('gpw-compare', GpwCompare);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gpw-pdp-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gpw-gallery')) {
    class GpwGallery extends HTMLElement {
      connectedCallback() {
        var root = this;
        var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-gpw-tile]'));
        if (!tiles.length) return;
        var lb = root.querySelector('[data-gpw-lightbox]');
        var stage = root.querySelector('[data-gpw-lb-stage]');
        var thumbsWrap = root.querySelector('[data-gpw-lb-thumbs]');
        var closeBtn = root.querySelector('[data-gpw-lb-close]');
        if (!lb || !stage) return;

        var media = tiles.map(function (t) {
          return { type: t.getAttribute('data-type'), src: t.getAttribute('data-src'), fit: t.getAttribute('data-fit') || 'cover' };
        });
        var idx = 0;

        function renderStage() {
          var m = media[idx];
          stage.innerHTML = '';
          var el;
          if (m.type === 'video') {
            el = document.createElement('video');
            el.src = m.src; el.autoplay = true; el.loop = true; el.muted = true;
            el.setAttribute('playsinline', ''); el.controls = true;
          } else {
            el = document.createElement('img');
            el.src = m.src; el.alt = '';
          }
          el.style.objectFit = 'contain';
          stage.appendChild(el);
          Array.prototype.forEach.call(thumbsWrap.children, function (th, i) {
            th.setAttribute('aria-current', i === idx ? 'true' : 'false');
          });
        }

        function buildThumbs() {
          thumbsWrap.innerHTML = '';
          media.forEach(function (m, i) {
            var b = document.createElement('button');
            b.type = 'button';
            b.className = 'pp-lightbox__thumb';
            b.setAttribute('aria-label', 'View ' + (i + 1));
            if (m.type === 'video') {
              var v = document.createElement('video'); v.src = m.src; v.muted = true; v.style.objectFit = 'cover';
              b.appendChild(v);
            } else {
              var im = document.createElement('img'); im.src = m.src; im.alt = ''; im.style.objectFit = 'cover';
              b.appendChild(im);
            }
            b.addEventListener('click', function () { idx = i; renderStage(); });
            thumbsWrap.appendChild(b);
          });
        }

        function open(i) {
          idx = i; lb.hidden = false;
          document.documentElement.style.overflow = 'hidden';
          renderStage();
        }
        function close() {
          lb.hidden = true;
          document.documentElement.style.overflow = '';
          stage.innerHTML = '';
        }
        function step(d) { idx = (idx + d + media.length) % media.length; renderStage(); }

        buildThumbs();
        tiles.forEach(function (t, i) { t.addEventListener('click', function () { open(i); }); });
        closeBtn.addEventListener('click', close);
        lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
        window.addEventListener('keydown', function (e) {
          if (lb.hidden) return;
          if (e.key === 'Escape') close();
          else if (e.key === 'ArrowRight') step(1);
          else if (e.key === 'ArrowLeft') step(-1);
        });
      }
    }
    customElements.define('gpw-gallery', GpwGallery);
  }

  if (!customElements.get('gpw-tabs')) {
    class GpwTabs extends HTMLElement {
      connectedCallback() {
        var pills = Array.prototype.slice.call(this.querySelectorAll('[data-gpw-tab]'));
        var panels = Array.prototype.slice.call(this.querySelectorAll('[data-gpw-panel]'));
        if (!pills.length) return;
        var self = this;
        function activate(i) {
          pills.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-gpw-tab') === String(i)); });
          panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-gpw-panel') === String(i)); });
        }
        pills.forEach(function (p) {
          p.addEventListener('click', function () { activate(p.getAttribute('data-gpw-tab')); });
        });
      }
    }
    customElements.define('gpw-tabs', GpwTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gpw-pdp-ingredients"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gpw-ingredients')) {
    class GpwIngredients extends HTMLElement {
      connectedCallback() {
        var root = this;
        var scrim = root.querySelector('[data-pp-dd-scrim]');
        var panel = root.querySelector('[data-pp-dd]');
        var scroll = root.querySelector('[data-pp-dd-scroll]');
        if (scrim && panel && scroll) {
          var lastTrigger = null;
          var closeDD = function () {
            scrim.classList.remove('is-open');
            panel.classList.remove('is-open');
            panel.setAttribute('aria-hidden', 'true');
            document.body.classList.remove('pp-dd-open');
            setTimeout(function () { if (!panel.classList.contains('is-open')) scrim.hidden = true; }, 340);
            if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
            lastTrigger = null;
          };
          var openDD = function (id, trigger) {
            var tpl = root.querySelector('template[data-dd="' + id + '"]');
            if (!tpl) return;
            lastTrigger = trigger || null;
            scroll.innerHTML = '';
            scroll.appendChild(tpl.content.cloneNode(true));
            scroll.scrollTop = 0;
            scrim.hidden = false;
            requestAnimationFrame(function () { scrim.classList.add('is-open'); });
            panel.classList.add('is-open');
            panel.setAttribute('aria-hidden', 'false');
            document.body.classList.add('pp-dd-open');
            var closeBtn = scroll.querySelector('.pp-dd__close');
            if (closeBtn) { closeBtn.addEventListener('click', closeDD); closeBtn.focus(); }
          };
          root.querySelectorAll('.pp-ing-card').forEach(function (card) {
            card.addEventListener('click', function () { openDD(card.getAttribute('data-ing'), card); });
          });
          scrim.addEventListener('click', closeDD);
          document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('is-open')) closeDD(); });
          var ddCta = panel.querySelector('[data-gpw-open-buy]');
          if (ddCta) ddCta.addEventListener('click', closeDD);
        }

        /* Mobile carousel: sync pagination dots + position counter with scroll */
        var grid = root.querySelector('.pp-ing__grid');
        var cards = Array.prototype.slice.call(root.querySelectorAll('.pp-ing-card'));
        var dots = Array.prototype.slice.call(root.querySelectorAll('[data-gpw-ing-dot]'));
        var currentEl = root.querySelector('[data-gpw-ing-current]');
        var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        function activeIndex() {
          if (!grid || !cards.length) return 0;
          var gr = grid.getBoundingClientRect();
          var center = gr.left + gr.width / 2;
          var best = 0, bestD = Infinity;
          cards.forEach(function (c, i) {
            var r = c.getBoundingClientRect();
            var d = Math.abs((r.left + r.width / 2) - center);
            if (d < bestD) { bestD = d; best = i; }
          });
          return best;
        }
        function syncNav() {
          var idx = activeIndex();
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
          if (currentEl) currentEl.textContent = String(idx + 1);
        }
        if (grid) {
          var ticking = false;
          grid.addEventListener('scroll', function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(function () { syncNav(); ticking = false; });
          });
          dots.forEach(function (d, i) {
            d.addEventListener('click', function () {
              if (cards[i]) cards[i].scrollIntoView({ inline: 'center', block: 'nearest', behavior: reduced ? 'auto' : 'smooth' });
            });
          });
          syncNav();
        }
      }
    }
    customElements.define('gpw-ingredients', GpwIngredients);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gpw-pdp-problem"] && !Shopify.designMode) return;
  try {
    
class GpwGoals extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('.pp-goal-tab'));
    this.desktopPanels = Array.from(this.querySelectorAll('.pp-goal-answer--desktop .pp-goal-panel'));
    this.mobileAnswers = Array.from(this.querySelectorAll('.pp-goal-answer--mobile'));
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab.dataset.index));
    });
  }
  activate(index) {
    this.tabs.forEach((tab) => {
      const on = tab.dataset.index === index;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    this.desktopPanels.forEach((panel) => {
      const on = panel.dataset.index === index;
      panel.classList.toggle('is-active', on);
      panel.hidden = !on;
    });
    this.mobileAnswers.forEach((ans) => {
      ans.classList.toggle('is-active', ans.dataset.index === index);
    });
  }
}
if (!customElements.get('gpw-goals')) {
  customElements.define('gpw-goals', GpwGoals);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gpw-sci-formula"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var root = document.querySelector('.gpw-sci-formula-section');
      if (!root || root.dataset.wired) return;
      root.dataset.wired = '1';
      var scrim = root.querySelector('[data-sci-scrim]');
      var panel = root.querySelector('[data-sci-dd]');
      var scroll = root.querySelector('[data-sci-dd-scroll]');
      if (!scrim || !panel || !scroll) return;
      var lastTrigger = null;

      function open(id, trigger) {
        var tpl = root.querySelector('template[data-dd="' + id + '"]');
        if (!tpl) return;
        lastTrigger = trigger || null;
        scroll.innerHTML = '';
        scroll.appendChild(tpl.content.cloneNode(true));
        scroll.scrollTop = 0;
        scrim.hidden = false;
        requestAnimationFrame(function () { scrim.classList.add('is-open'); });
        panel.classList.add('is-open');
        panel.setAttribute('aria-hidden', 'false');
        document.body.classList.add('sci-dd-open');
        var closeBtn = scroll.querySelector('.sci-dd__close');
        if (closeBtn) { closeBtn.addEventListener('click', close); closeBtn.focus(); }
      }
      function close() {
        scrim.classList.remove('is-open');
        panel.classList.remove('is-open');
        panel.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('sci-dd-open');
        setTimeout(function () { if (!panel.classList.contains('is-open')) scrim.hidden = true; }, 320);
        if (lastTrigger && lastTrigger.focus) lastTrigger.focus();
        lastTrigger = null;
      }

      root.addEventListener('click', function (e) {
        // Anywhere on a card opens its deep dive (the Read more button stays the keyboard target)
        var card = e.target.closest && e.target.closest('.ing');
        var btn = card && card.querySelector('.ing__more');
        if (btn) { e.preventDefault(); open(btn.getAttribute('data-ing'), btn); }
      });
      scrim.addEventListener('click', close);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('is-open')) close(); });

      // Mobile carousel dots
      var track = root.querySelector('.sci-formula__groups');
      var dotsWrap = root.querySelector('[data-sci-dots]');
      if (track && dotsWrap) {
        var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.sci-dot'));
        var cards = function () { return Array.prototype.slice.call(track.querySelectorAll('.ing')); };
        var update = function () {
          var tl = track.getBoundingClientRect().left, best = 0, bd = Infinity;
          cards().forEach(function (c, i) { var d = Math.abs(c.getBoundingClientRect().left - tl); if (d < bd) { bd = d; best = i; } });
          dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === best); });
        };
        var raf = null;
        track.addEventListener('scroll', function () { if (raf) return; raf = requestAnimationFrame(function () { raf = null; update(); }); }, { passive: true });
        dots.forEach(function (dot, i) { dot.addEventListener('click', function () { var c = cards()[i]; if (c) c.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' }); }); });
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gpw-sci-sticky"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var bar = root.querySelector('[data-sci-sticky]');
    if (!bar || bar.dataset.wired) return;
    bar.dataset.wired = '1';

    var footer = document.querySelector('.gpw-ft__body') || document.querySelector('.gpw-ft') || document.querySelector('footer');

    function update() {
      var past = window.pageYOffset > window.innerHeight * 0.9;
      var footerClear = true;
      if (footer) {
        // Footer is "reached" once its top rises above the bottom 40px of the viewport.
        footerClear = footer.getBoundingClientRect().top > window.innerHeight - 40;
      }
      if (past && footerClear) bar.classList.add('is-on');
      else bar.classList.remove('is-on');
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  document.querySelectorAll('.gpw-sci-sticky-section').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList.contains('gpw-sci-sticky-section')) init(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gpw-sci-why"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initLazyVideos() {
      var vids = document.querySelectorAll('.gpw-sci .sci-why__video video[data-src]');
      if (!vids.length) return;
      var attach = function (v) { if (v.src) return; v.src = v.dataset.src; v.load(); var p = v.play(); if (p && p.catch) p.catch(function () {}); };
      if (!('IntersectionObserver' in window)) { vids.forEach(attach); return; }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { attach(e.target); io.unobserve(e.target); } });
      }, { rootMargin: '200px' });
      vids.forEach(function (v) { io.observe(v); });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLazyVideos);
    else initLazyVideos();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
